import * as React from 'react';

export const LazyElevatedRiskOneToThreeYearsExclusion = React.lazy(() => import('./component'));
